export default "__VITE_ASSET__6a16056a__"